/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Withdrawal_TitleInputs */

const en_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Right of Withdrawal`)
};

const de_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Widerrufsrecht`)
};

const fr_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Droit de rétractation`)
};

const es_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Derecho de desistimiento`)
};

const it_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Diritto di recesso`)
};

const nl_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Herroepingsrecht`)
};

const pl_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Prawo do odstąpienia`)
};

const fi_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Peruuttamisoikeus`)
};

const da_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Fortrydelsesret`)
};

const sv_agb_withdrawal_title = /** @type {(inputs: Agb_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Ångerrätt`)
};

/**
* | output |
* | --- |
* | "7. Right of Withdrawal" |
*
* @param {Agb_Withdrawal_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_withdrawal_title = /** @type {((inputs?: Agb_Withdrawal_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Withdrawal_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_withdrawal_title(inputs)
	if (locale === "fr") return fr_agb_withdrawal_title(inputs)
	if (locale === "es") return es_agb_withdrawal_title(inputs)
	if (locale === "it") return it_agb_withdrawal_title(inputs)
	if (locale === "nl") return nl_agb_withdrawal_title(inputs)
	if (locale === "pl") return pl_agb_withdrawal_title(inputs)
	if (locale === "fi") return fi_agb_withdrawal_title(inputs)
	if (locale === "da") return da_agb_withdrawal_title(inputs)
	if (locale === "sv") return sv_agb_withdrawal_title(inputs)
	return en_agb_withdrawal_title(inputs)
});